/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { TextField, Autocomplete } from "@mui/material";

const GenericSelectMUI = ({
  name,
  value,
  label,
  placeholder,
  disabled,
  options,
  loading,
  required,
  showAllOption,
  getValue,
  setValue,
  onChange,
}) => {
  const [formattedOptions, setFormattedOptions] = useState([]);

  useEffect(() => {
    if (options?.length) {
      const fOptions = options.map((item) => ({
        value: item?.value,
        label: item?.title,
      }));

      if (showAllOption) {
        fOptions.unshift({ value: "", label: "All" });
      }

      setFormattedOptions(fOptions);
    }
  }, [options, showAllOption]);

  return (
    <Autocomplete
      fullWidth
      disabled={disabled}
      getOptionLabel={(option) =>
        option?.label ??
        formattedOptions.find(
          (opt) => opt.value.toLowerCase() === label.toLowerCase()
        )?.label
      }
      isOptionEqualToValue={(o, v) => o.value === v}
      isRequired={required}
      loading={loading}
      options={formattedOptions}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder={placeholder} />
      )}
      size="medium"
      value={getValue(value)}
      onChange={(_, option) => {
        onChange(name, setValue(option?.value));
      }}
    />
  );
};

GenericSelectMUI.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  required: PropTypes.bool,
  showAllOption: PropTypes.bool,
  options: PropTypes.array,
  getValue: PropTypes.func,
  setValue: PropTypes.func,
  onChange: PropTypes.func,
};

GenericSelectMUI.defaultProps = {
  name: "",
  placeholder: "",
  label: "",
  disabled: false,
  loading: false,
  required: false,
  showAllOption: false,
  options: [],
  getValue: (x) => x,
  setValue: (x) => x,
  onChange: () => {},
};

export default GenericSelectMUI;
